<template>
  <div class="apply-add-form">
    <template v-if="fromShow">
      <my-form ref="formRef" :vacation-credit-detail-list="vacationCreditDetailList" :data.sync="data"
        :loading="loading" :option="option" width="auto" class="mcc-add-form" :footer-visible="false"
        @submit="handleSubmit" />
      <!-- submit and reset -->

      <b-col cols="12" class="my-form_btns mcc-my-form-btns">
        <!-- <p class="text-secondary">
            {{ explain }}
          </p> -->
        <b-button v-if="draftBtnList.includes(Number(formId))" class="text-btn" :disabled="loading || submitDisabled"
          @click="saveDrafts">
          {{ $t('_components.btns.saveDrafts') }}
        </b-button>
        <b-button class="primary-btn" :disabled="loading || submitDisabled" @click="send">
          {{ $t('_components.btns.send') }}
        </b-button>
      </b-col>
    </template>
    <component :is="flowKey" v-else :process-key="processKey" :explain="explain" @cancel="handleCustFormCancel"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue'
import applyAPI from '@/api/apply/index'
import positiveRecordAPI from '@/api/staff/positiveRecord/index'
import vacationAPI, { getAnnualDays } from '@/api/staff/vacation/index'
import benefitAPI from '@/api/staff/benefit/index'
import templateFormAPI from '@/api/templateForm/index'
import { getStore } from '@/util/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import website from '@/config/website'
import { templateFormat, templateSubmitFormat } from '@/util/func'
import { mapGetters } from 'vuex'
// custForm
import { deepClone } from '@/util/util'
import TransferProject from './custForm/transferProject.vue'
import Induction from './custForm/induction.vue'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    Induction,
    TransferProject,
  },
  props: {
    formId: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    explain: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      fromShow: true,
      flowKey: '',
      form: {
        isPass: false,
      },
      draftBtnList: [
        2,
        33,
        18,
        1,
        7,
        11,
        15,
        21,
        22,
        33,
        36,
        40,
        43,
        101,
        102,
        103,
        104,
        305,
        316, // PR Support Request
      ],
      pageConfirmationAssessment: [],
      isDrafts: false,
      loading: false,
      data: {
        deptId: null,
        formerDept: null,
        usedDaysTitle: null,
        haveDaysTitle: null,
        isLeave: null,
        leaveUnit: '1',
        // leaveStartTime: null,
        // leaveEndTime: null,
        usedDays: 0,
        vacationName: '',
        sectionA: '',
        sectionARemark: '',
        sectionBOperateOwn: '',
        sectionBOperateOwnTable: '',
        sectionBImmediateFamily: '',
        sectionBImmediateFamilyTable: '',
      },
      vacationCreditDetailList: [],
      columns: [],
      hasDept: false,
      currentYear: moment(new Date()).format('YYYY'),
      dateList: [],
      hasLeaveList: [],
      submitDisabled: false,
      prApplicantStaffField: '',
      _prApplicantStaffIdCache: undefined,
      _prStaffUnwatch: null,
    }
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    companyId() {
      return (
        this.userAllInfo.staffInfo.companyId ||
        this.userAllInfo.workerInfo.companyId
      )
    },
    workTime() {
      return this.userAllInfo.staffInfo.workTime || ''
    },
    option() {
      const columns = []
      const { data } = this
      this.columns.forEach((item) => {
        const dictQuery = item.formOption.dictQuery || {}
        const temp = item
        if (this.formId === 2 || this.formId === '2') {
          if (item.field === 'departureDate' || item.field === 'arrivalDate') {
            temp.formOption.hide = Number(data.isLeave) !== 1
          }
          if (
            item.field === 'usedDaysTitle' ||
            item.field === 'haveDaysTitle' ||
            item.field === 'pendingDays'
          ) {
            if (this.data.vacationInfoId) {
              temp.formOption.hide = false
            } else {
              temp.formOption.hide = true
            }
          }
          if (item.field === 'leaveStartTime') {
            // const currentDate = `${moment(new Date()).format('YYYY')}-01-01`
            let currentDate = moment(new Date())
              .subtract(90, 'days')
              .format('YYYY-MM-DD')
            if (this.data.vacationName === 'Birthday Leave') {
              currentDate = moment()
                .startOf('month')
                .format('YYYY-MM-DD')
            }
            // console.log(currentDate)
            temp.formOption.minDate = `${currentDate}`
          }
          if (item.field === 'leaveEndTime') {
            if (this.data.leaveUnit === '0.5') {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
            // const currentDate = `${moment(new Date()).format('YYYY')}-01-01`
            let currentDate = moment(new Date())
              .subtract(90, 'days')
              .format('YYYY-MM-DD')
            if (this.data.vacationName === 'Birthday Leave') {
              currentDate = this.birthdayEndMinDate()
            }
            temp.formOption.minDate = `${currentDate}`
          }
          if (item.field === 'leavePeriod') {
            if (this.data.leaveUnit !== '0.5') {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }

          if (item.field === 'leaveUnit') {
            if (this.data.minLeaveUnit === '0.5') {
              temp.formOption.hide = false
            } else {
              temp.formOption.hide = true
            }
          }
          if (item.field === 'files') {
            console.log(item)
            // if (this.vacationDayParams.forceUploadAttach) {
            //   temp.formOption.rules = 'required'
            // }
          }

          if (item.field === 'usedDays') {
            // temp.formOption.numberMax = 999
            // temp.formOption.numberMin = 0
            if (this.data.leaveUnit === '0.5') {
              temp.formOption.disabled = true
              // this.data.usedDays = '0.5'
            }
          }
        }
        if (item.formOption.dictCode === 'dept') {
          dictQuery.parentId = this.companyId
          this.hasDept = true
        }
        if (item.formOption.dictCode === 'post') {
          let key = 'deptId'
          if (item.field === 'formerPost') {
            key = 'formerDept'
          }
          if (item.field === 'newPost') {
            key = 'newDept'
          }

          dictQuery.deptId = data[key]
          temp.disabled = !data[key]
          temp.formOption.small =
            this.$t('_components.placeholder.firstInput') +
            this.i18n('labelEmployment.deptId')
        }
        if (item.field === 'staffIds' && this.formId === '5') {
          temp.formOption.hide = true
        }
        if (item.field === 'staffId') {
          console.log(temp.formOption, 'temp.formOptiontemp.formOption')
          // temp.formOption.disabled = true
        }
        if (item.field === 'positiveRecordIds' && this.formId === '5') {
          temp.formOption.hide = false
        }
        if (this.formId == 11) {
          if (
            item.field === 'travelReimbursement' ||
            item.field === 'totalPerDiem'
          ) {
            temp.formOption.hide = true
          }
        }

        if (Number(this.formId) === 316) {
          if (
            ['employeeCodeApplicant', 'jointDate', 'nationalityApplicant'].includes(
              temp.field,
            )
          ) {
            temp.formOption.disableFormControl = true
          }

          if (temp.field === 'purposeApplication') {
            temp.formOption.textareaRows = 14
          }

          const fieldType = String(
            temp.type || temp.formOption?.type || '',
          ).toLowerCase()
          const isCheckbox =
            fieldType === 'checkbox'
            || fieldType === 'check'
            || /declaration|acknowledgement/i.test(String(temp.label || ''))
          const isRequired = String(temp.formOption.rules || '').includes(
            'required',
          )
          if (isCheckbox && isRequired) {
            if (this.isDrafts) {
              temp.formOption.rules = ''
            } else {
              const total = temp.formOption.dictData?.length
              if (total) {
                temp.formOption.rules = `checkboxRequired:${total}`
              } else {
                temp.formOption.rules = 'checkboxRequired'
              }
            }
          }
        }

        temp.formOption.dictQuery = dictQuery
        columns.push(temp)
      })
      const option = {
        columns,
      }
      return option
    },
    benefitParams() {
      return {
        staffId: this.data.staffId,
        benefitType: this.data.benefitType,
      }
    },
    vacationDayParams() {
      return {
        staffId: this.data.staffId,
        vacationInfoId: this.data.vacationInfoId,
        forceUploadAttach: this.data.forceUploadAttach,
      }
    },
    isOverHaveDays() {
      return this.data.haveDaysTitle >= 0
    },
    isOverMaxLeaveDays() {
      const useDays = Number(this.data.usedDays)
      const maximumLeaveUnit = Number(this.data.maximumLeaveUnit)
      return useDays > maximumLeaveUnit
    },
    isOverUsedBenefit() {
      // const haveBenefit = Number(this.data.haveBenefitTitle)
      // const usedBenefit = Number(this.data.usedBenefitTitle)
      const useBenefit = Number(this.data.usedBenefit)
      const balanceBenefit = Number(this.data.balanceTitle)
      console.log(useBenefit, balanceBenefit, 'useBenefituseBenefit')

      return useBenefit <= balanceBenefit
    },
  },
  watch: {
    'benefitParams.benefitType': {
      handler(e) {
        if (this.data.staffId && e) {
          this.getUseBenefit(this.benefitParams)
        }
      },
      immediate: true,
    },
    'data.positiveRecordIds': {
      handler(e) {
        if (Number(this.formId) === 5) {
          if (e && e.length > 0) {
            const staffIds = this.pageConfirmationAssessment
              .filter((item) => e.indexOf(item.id) !== -1)
              .map((item) => item.staffId)
            this.data.staffIds = staffIds || []
          } else {
            this.data.staffIds = []
          }
        }
      },
      immediate: true,
      deep: true,
    },
    'vacationDayParams.vacationInfoId': {
      handler(e) {
        if (this.data.staffId && e) {
          this.getVacationDay(this.vacationDayParams)
        }
      },
      immediate: true,
    },
    'data.vacationInfoId': {
      handler(newVal, oldVal) {
        delete this.data.leaveStartTime
        delete this.data.leaveEndTime
        this.data.leaveUnit = '1'
      },
    },
    'data.leaveStartTime': {
      handler(val, oldVal) {
        if (!val) {
          return
        }
        if (
          this.data.vacationName === 'Birthday Leave' &&
          this.data.leaveEndTime &&
          oldVal &&
          !moment(val).isSame(oldVal, 'day')
        ) {
          this.data.leaveEndTime = null
        }
        if (
          this.data.leaveEndTime &&
          moment(val).isAfter(this.data.leaveEndTime, 'day')
        ) {
          this.data.leaveEndTime = null
        }

        const index = this.option.columns.findIndex(
          (item) => item.field === 'leaveEndTime'
        )
        const newFormOption = this.option.columns[index]
        newFormOption.formOption.minDate = moment(val)
          .add(0, 'days')
          .format('YYYY-MM-DD')

        this.$set(this.option.columns, index, newFormOption)

        if (this.data.leaveUnit === '0.5' && this.data.vacationInfoId) {
          delete this.data.leaveEndTime
          this.getSunDay()
        }

        if (this.data.leaveEndTime && this.data.vacationInfoId) {
          this.getSunDay()
        }
        if (val != oldVal) {
          this.submitDisabled = !this.getLeaveUnit()
        }
      },
      deep: true,
    },
    'data.leaveEndTime': {
      handler(val, oldVal) {
        console.log(val)
        if (!val) {
          return
        }

        if (this.data.leaveStartTime && this.data.vacationInfoId) {
          this.getSunDay()
        }
        if (this.data.leaveStartTime) {
          if (this.data.leaveUnit === '1' || this.data.leaveUnit === 1) {
            if (moment(this.data.leaveStartTime).isAfter(val, 'day')) {
              this.data.leaveEndTime = null
            }
          }
          if (val != oldVal) {
            this.submitDisabled = !this.getLeaveUnit()
          }
        }
      },
      deep: true,
    },
    'data.leaveUnit': {
      handler(val) {

        delete this.data.leaveStartTime
        delete this.data.leaveEndTime
        this.data.usedDays = 0
   
      },
    },
    'data.leavePeriod': {
      handler(val) {
        if (this.data.leaveStartTime) {
          this.submitDisabled = !this.getLeaveUnit()
        }
      },
    },
    'data.sectionA': {
      handler(val) {
        const index = this.option.columns.findIndex(
          (item) => item.field === 'sectionARemark'
        )
        const newFormOption = this.option.columns[index]
        console.log(newFormOption)
        const sectionA = JSON.parse(this.data.sectionA)
        const tickValue = sectionA[7].tickValue
        newFormOption.formOption.rules = tickValue == 1 ? 'required' : ''

        this.$set(this.option.columns, index, newFormOption)
      },
    },
    'data.sectionBOperateOwn': {
      handler(val) {
        const index = this.option.columns.findIndex(
          (item) => item.field === 'sectionBOperateOwnTable'
        )
        const newFormOption = this.option.columns[index]
        newFormOption.formOption.rules = val == 1 ? 'required' : ''
        newFormOption.formOption.hide = val == 1 ? false : true
        // this.data.sectionBOperateOwnTable = ''

        this.$set(this.option.columns, index, newFormOption)
      },
    },
    'data.sectionBImmediateFamily': {
      handler(val) {
        const index = this.option.columns.findIndex(
          (item) => item.field === 'sectionBImmediateFamilyTable'
        )
        const newFormOption = this.option.columns[index]
        newFormOption.formOption.rules = val == 1 ? 'required' : ''
        newFormOption.formOption.hide = val == 1 ? false : true
        // this.data.sectionBImmediateFamilyTable = ''

        this.$set(this.option.columns, index, newFormOption)
      },
    },

    'data.sectionCRadio': {
      handler(val) {
        const index = this.option.columns.findIndex(
          (item) => item.field === 'sectionCRemark'
        )
        const newFormOption = this.option.columns[index]
        newFormOption.formOption.rules = val == 1 ? 'required' : ''

        // this.data.sectionBImmediateFamilyTable = ''

        this.$set(this.option.columns, index, newFormOption)
      },
    },
  },
  mounted() {
    if (this.formId) {
      if (Number(this.formId) === 6) {
        this.flowKey = 'Induction'
        this.fromShow = false
      } else if (Number(this.formId) === 35) {
        this.flowKey = 'TransferProject'
        this.fromShow = false
      } else {
        this.onLoad(this.formId)
      }
    }
    if (this.formId == 2) {
      this.getMyLeaveRecordDays()
    }

    if (Number(this.formId) === 5) {
      applyAPI.pageConfirmationAssessment(1, -1, { status: 7 }).then((res) => {
        this.pageConfirmationAssessment = res.data.data.records
      })
    }
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    validationForm() {
      // console.log(this.form, 'submit');
    },
    resetForm() {
      this.form = {}
    },
    async applyPrApplicantStaff(staffId) {
      if (Number(this.formId) !== 316 || !this.prApplicantStaffField) return
      const nextId = staffId == null ? '' : String(staffId)
      if (nextId === String(this._prApplicantStaffIdCache ?? '')) return
      this._prApplicantStaffIdCache = staffId

      if (!staffId || staffId === -1 || staffId === '-1') {
        Object.assign(this.data, {
          employeeCodeApplicant: '',
          jointDate: '',
          nationalityApplicant: '',
        })
        this.refreshTmplate()
        return
      }

      const id = String(staffId).split(',')[0]
      let record
      for (let i = 0; i < 15; i += 1) {
        if (id !== String(this._prApplicantStaffIdCache ?? '').split(',')[0]) return
        const cached = getStore({ name: `dictsStaticData-staff-${id}` })
        record = Array.isArray(cached)
          && (cached.find((o) => String(o.id) === id) || cached[0])
        if (record) break
        await new Promise((resolve) => setTimeout(resolve, 100))
      }
      if (!record) return

      Object.assign(this.data, {
        employeeCodeApplicant: record.staffNo || '',
        jointDate: record.joinDate || '',
        nationalityApplicant: record.nationalityName || '',
      })
      this.refreshTmplate()
    },
    initPrApplicantStaffWatch() {
      if (Number(this.formId) !== 316 || !this.prApplicantStaffField) {
        return
      }
      if (this._prStaffUnwatch) {
        this._prStaffUnwatch()
      }
      const field = this.prApplicantStaffField
      this._prStaffUnwatch = this.$watch(
        () => this.$refs.formRef?.form?.[field],
        (staffId) => {
          this.applyPrApplicantStaff(staffId)
        },
      )
      this._prApplicantStaffIdCache = undefined
      this.applyPrApplicantStaff(
        this.$refs.formRef?.form?.[field] ?? this.data[field],
      )
    },
    onLoad(formId) {
      templateFormAPI.detail({ formId }).then((res) => {
        const temp = res.data.data.records
        this.allTempList = temp
        this.columns = templateFormat(temp) // , setDictQuery)
        this.columns.forEach((item) => {
          if (item.field === 'staffId') {
            // eslint-disable-next-line no-param-reassign
            // item.formOption.disabled = false
          }
        })
        if (Number(formId) === 316) {
          const disabled = [
            'employeeCodeApplicant',
            'jointDate',
            'nationalityApplicant',
          ]
          const applicantCol =
            this.columns.find((col) =>
              /name of applicant/i.test(String(col.label || '')),
            )
            || this.columns.find((col) => col.field === 'applicantId')
            || this.columns.find((col) => {
              const dictCode =
                col.formOption?.dictCode || col.formOption?.dictBizCode
              return dictCode === 'staff' && !disabled.includes(col.field)
            })
          this.prApplicantStaffField = applicantCol?.field || 'applicantId'
          ;[
            this.prApplicantStaffField,
            'employeeCodeApplicant',
            'jointDate',
            'nationalityApplicant',
          ].forEach((field) => {
            if (!Object.prototype.hasOwnProperty.call(this.data, field)) {
              this.$set(this.data, field, null)
            }
          })
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.initPrApplicantStaffWatch()
            })
          })
        }
      })
    },
    getSunDay() {
      const allDays =
        moment(this.data.leaveEndTime).diff(this.data.leaveStartTime, 'day') + 1

      // 工作日判断
      const sunDays = 0
      console.log('this.data.calculationType', this.data.calculationType)
      if (this.data.calculationType === 1 && this.workTime == 1) {
        let isHalf = 1
        if (this.data.minLeaveUnit === '0.5') {
          isHalf = 1
        }
        const endTime =
          this.data.leaveUnit === '0.5'
            ? this.data.leaveStartTime
            : this.data.leaveEndTime
        getAnnualDays({
          startDate: this.data.leaveStartTime,
          endDate: endTime,
          vacationInfoId: this.data.vacationInfoId,
          isHalf,
        }).then((res) => {
          
          this.data.usedDays =
            this.data.leaveUnit === '0.5' && res.data.data >= 1 && !this.data.roundUp
              ? 0.5
              : res.data.data
          this.refreshTmplate()
        })
        // if (this.data.leaveUnit === '0.5') {
        //   // this.data.leaveEndTime = ''
        //   this.data.usedDays = '0.5'
        // } else {
        //   getAnnualDays({
        //     startDate: this.data.leaveStartTime,
        //     endDate: this.data.leaveEndTime,
        //     isHalf,
        //   }).then((res) => {
        //     this.data.usedDays = res.data.data
        //     this.refreshTmplate()
        //   })
        // }
      }
      // 自然日判断
      if (this.data.calculationType === 2 || this.workTime == 2) {
        this.data.usedDays = this.data.leaveUnit === '0.5' && !this.data.roundUp ? 0.5 : allDays
      }

      this.$nextTick(() => {
        this.refreshTmplate()
      })
    },
    send() {
      this.isDrafts = false
      const runValidate = () => this.$refs.formRef.validationForm()
      if (Number(this.formId) === 316) {
        this.$nextTick(() => {
          this.$nextTick(runValidate)
        })
      } else {
        this.$nextTick(runValidate)
      }
    },
    saveDrafts() {
      this.isDrafts = true
      this.$nextTick(() => {
        this.$refs.formRef.validationForm()
      })
    },
    refreshTmplate() {
      this.columns = templateFormat(this.allTempList)
      this.Birthday()
    },
    handleSubmit(form) {
      this.loading = true
      const params = templateSubmitFormat(form, this.columns)
      params.processKey = this.processKey
      params.formId = this.formId
      if(this.formId ==2){
        params.workTime = this.workTime
      }
      const router = website.staffProcessRouter
      if (
        this.formId === 2 &&
        params.leaveEndTime &&
        params.leaveStartTime &&
        params.vacationName == 'Annual Leave'
      ) {
        const date1 = moment(params.leaveEndTime)
        const date2 = moment(params.leaveStartTime)
        const daysDiff = date1.diff(date2, 'days')
        console.log(daysDiff)
        if (daysDiff + 1 > 21) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text:
                'To ensure that the leave request is valid, the interval between the leave start time and leave end time must not exceed 21 days',
              variant: 'danger',
            },
          })
          this.loading = false
          return
        }
      }

      if (this.hasDept) {
        params.companyId = this.companyId
      }
      if (params.formId == 305) {
        if (params.sectionBOperateOwn != 1) {
          params.sectionBOperateOwnTable = ''
        }
        if (params.sectionBImmediateFamily != 1) {
          params.sectionBImmediateFamilyTable = ''
        }
      }
      if (this.isDrafts) {
        applyAPI.add(params, router[params.formId]).then((res) => {
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.loading = false
        })
      } else {
        // 请假流程判断
        if (this.formId === 2 || this.formId === '2') {
          if (!this.isOverHaveDays) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.i18n('labelVacation.addTip'),
                variant: 'danger',
              },
            })
            this.loading = false
            return
          }
          if (!this.data.usedDays || Number(this.data.usedDays) <= 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.i18n('labelVacation.leaveDayTip'),
                variant: 'danger',
              },
            })
            this.loading = false
            return
          }

          if (
            this.isOverMaxLeaveDays ||
            this.data.usedDays > this.data.haveDaysTitle
          ) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.i18n('labelVacation.addMaxTip'),
                variant: 'danger',
              },
            })
            this.loading = false
            return
          }
          if (this.hasLeaveList.length) {
            const days = this.hasLeaveList.join(',')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: days + this.i18n('labelVacation.leaveLimitTip'),
                variant: 'danger',
              },
            })
            return
          }
          // eslint-disable-next-line eqeqeq
          if (this.data.usedDays == 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.i18n('labelVacation.notLeaveDays'),
                variant: 'danger',
              },
            })
            return
          }
        }

        if (this.formId === 40 || this.formId === '40') {
          if (!this.isOverUsedBenefit) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.i18n('labelBenefit.addTip'),
                variant: 'danger',
              },
            })
            this.loading = false
            return
          }
        }
        console.log(params, !this.data.fileIds)
        if (
          this.formId == 2 &&
          this.data.forceUploadAttach &&
          !params.fileIds
        ) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: 'please upload file',
              variant: 'danger',
            },
          })
          console.log(params, 'ssssssssss')
          this.loading = false
          return
        }
        // 发起流程
        if (this.formId === 25999) {
          positiveRecordAPI
            .saveConfirmationAssessment({ variables: params })
            .then((res) => {
              this.$emit('close')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
              this.loading = false
            })
        } else {
          applyAPI
            .saveAndStart(params, router[params.formId])
            .then((res) => {
              this.$emit('close')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
            })
        }
      }
    },
    handleCustFormCancel() {
      this.flowKey = ''
      this.fromShow = true
      this.onLoad(this.formId)
    },
    getVacationDay(params) {
      const year = moment(new Date()).format('YYYY')
      const vacationsParams = { ...params, year }
      vacationAPI.vacationDetail(vacationsParams).then((res) => {
        const temp = res.data.data || {}
        const haveDays =
          Number(temp.haveDays) -
          Number(temp.usedDays) -
          Number(temp.pendingDays) || 0
        const usedDays = Number(temp.usedDays) || 0
        this.data.usedDaysTitle = parseFloat(usedDays)
        this.data.haveDaysTitle = parseFloat(haveDays)
        this.data.usedDays = '0'
        // this.data.usedDays = parseFloat(haveDays) > 0 ? parseFloat(haveDays) - parseFloat(usedDays) : 0
        // 自然日 工作日
        this.data.calculationType = temp.calculationType
        this.data.minLeaveUnit = temp.minLeaveUnit
        this.data.maximumLeaveUnit = temp.maximumLeaveUnit
        this.data.vacationName = temp.vacationName
        this.vacationCreditDetailList = temp.vacationCreditDetailList || []
        this.data.pendingDays = parseFloat(temp.pendingDays)
        this.data.forceUploadAttach = temp.forceUploadAttach || false
        this.data.roundUp = temp.roundUp || false
        this.refreshTmplate()
      })
    },
    getMyLeaveRecordDays() {
      vacationAPI.getMyLeaveRecordDays().then((res) => {
        const dateList = res.data.data.map((el) =>
          moment(el).format('YYYY-MM-DD')
        )
        this.dateList = res.data.data
      })
    },
    getUseBenefit(params) {
      benefitAPI
        .getBenefitDetail({ ...params, year: this.currentYear })
        .then((res) => {
          const temp = res.data.data || {}
          const haveBenefit = Number(temp.haveBenefit) || 0
          const usedBenefit = Number(temp.usedBenefit) || 0
          const pendingBenefit = Number(temp.pendingBenefit) || 0
          this.data.usedBenefitTitle = parseFloat(usedBenefit)
          this.data.haveBenefitTitle = parseFloat(haveBenefit)
          this.data.pendingBenefit = parseFloat(pendingBenefit)
          this.data.year = this.currentYear
          this.data.balanceTitle =
            this.data.haveBenefitTitle -
            this.data.usedBenefitTitle -
            this.data.pendingBenefit
          this.refreshTmplate()
        })
    },
    birthdayEndMinDate() {
      const monthStart = moment().startOf('month').format('YYYY-MM-DD')
      if (!this.data.leaveStartTime) return monthStart
      const start = moment(this.data.leaveStartTime).format('YYYY-MM-DD')
      return moment(start).isBefore(monthStart, 'day') ? monthStart : start
    },
    Birthday() {
      if (this.data.vacationName === 'Birthday Leave') {
        const startIndex = this.option.columns.findIndex(
          (item) => item.field === 'leaveStartTime'
        )
        const endIndex = this.option.columns.findIndex(
          (item) => item.field === 'leaveEndTime'
        )
        const newFormOptionStart = this.option.columns[startIndex]
        const newFormOptionEnd = this.option.columns[endIndex]
        const monthStart = moment().startOf('month').format('YYYY-MM-DD')
        const monthEnd = moment().endOf('month').format('YYYY-MM-DD')
        newFormOptionStart.formOption.minDate = monthStart
        newFormOptionStart.formOption.maxDate = monthEnd

        newFormOptionEnd.formOption.minDate = this.birthdayEndMinDate()
        newFormOptionEnd.formOption.maxDate = monthEnd

        this.$set(this.option.columns, startIndex, newFormOptionStart)
        this.$set(this.option.columns, endIndex, newFormOptionEnd)
      }
    },

    //判断请假范围
    getLeaveUnit() {
      if (!this.dateList?.length) return true
      if (!this.data.leaveStartTime) return true
      if (Number(this.data.leaveUnit) !== 0.5 && !this.data.leaveEndTime) return true

      const start = moment(this.data.leaveStartTime)
      const end = moment(this.data.leaveEndTime)

      // 遍历用户选择的区间每一天
      const checkDate = (dateStr) => {
        const current = this.dateList.filter(
          (item) => item.leaveDate == dateStr
        )
        if (!current.length) return true // 当天无记录 → OK

        // 用户当前申请信息
        const uUnit = Number(this.data.leaveUnit) // 1 或 0.5
        const uPeriod = this.data.leavePeriod // '', '1', '2'

        // 统计当日之前的情况
        const totalHalf = current.filter((i) => Number(i.leaveUnit) === 0.5)
          .length
        const hasFull = current.some((i) => Number(i.leaveUnit) === 1)

        // === 情况 A：用户申请整天 ===
        if (uUnit === 1) {
          if (hasFull || totalHalf >= 1) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: dateStr + this.i18n('labelVacation.leaveLimitTip'),
                variant: 'danger',
              },
            })
            return false
          }
          return true
        }
        // === 情况 B：用户申请半天（0.5） ===
        if (uUnit === 0.5) {
          // 1）当天已有整天假
          if (hasFull) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: dateStr + this.i18n('labelVacation.leaveLimitTip'),
                variant: 'danger',
              },
            })

            return false
          }

          // 2）用户未选择上午/下午
          if (!uPeriod) {
            if (totalHalf >= 2) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: dateStr + this.i18n('labelVacation.leaveLimitTip'),
                  variant: 'danger',
                },
              })

              return false
            }
            return true
          }

          // 3）用户选择了上午/下午

          const samePeriod = current.some(
            (i) => Number(i.leaveUnit) === 0.5 && i.leavePeriod === uPeriod
          )

          if (samePeriod) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text:
                  dateStr +
                  (uPeriod == 1 ? ' Morning 上午' : 'Afternoon 下午 ') +
                  this.i18n('labelVacation.leaveLimitTip'),
                variant: 'danger',
              },
            })

            return false
          }

          return true
        }

        return true
      }

      // 遍历日期区间或单日校验
      if (Number(this.data.leaveUnit) === 0.5) {
        // 半天请假，只校验当天
        const day = start.format('YYYY-MM-DD')
        return checkDate(day)
      } else {
        // 整天请假，需要遍历日期区间
        let curr = start.clone()
        while (curr.isSameOrBefore(end)) {
          const d = curr.format('YYYY-MM-DD')
          if (!checkDate(d)) return false
          curr = curr.add(1, 'day')
        }
        return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.apply-add-form {
  height: 100%;
  position: relative;

  .my-form {
    height: calc(100% - 40px);
    position: relative;
    overflow: hidden;

    &_btns {
      left: 0;
      right: 0;
      position: absolute;
      bottom: 0;
      text-align: center;
      border-top: 1px solid #ebe9f1;
      background: #fff;
      padding: 1rem 0;
    }
  }
}
</style>
